
import errorService from '@/services/errorService';
import Vue from 'vue';
import XCardBasedForm from "@/components/XCardBasedForm.vue";
import {TOTP_REGEX} from "@/constant/regex";
import msDataProvider from "@/services/msDataProvider";
import {OtpType} from "@/constant/login";
import uiService from "@/services/uiService";

export default Vue.extend({
  name: "ForgotPassword",
  components: {
    XCardBasedForm,
  },
  data() {
    return {
      required: (value, label) => !!value || (label || '') + ' ' + this.$t("USERNAME_PASSWORD.REQUIRED"),
      data: {},
      errorService,
      steps: {
        USERNAME: 1,
        OTP: 2,
        NEW_PASSWORD: 3,
        NOTI: 4
      },
      step: 1,
      loading: false,
      showMenu: false,
      otpTypeItems: [],
      selectedTypeItem: "",
      error: "",
      showPwd: false,
      showConfirmPwd: false,
      requestChangePassRes: {},
      pageOtpLoading: false,
      resendLoading: {
        [OtpType.SMS]: 0,
        [OtpType.EmailOtp]: 0,
      },
      submitCb: null,
    }
  },
  computed: {
    confirmPasswordRule() {
      return (v) => v === this.data.password || this.$t('USERNAME_PASSWORD.CONFIRM_PASSWORD_NOT_VALID')
    },
    buttonLabel() {
      return this.step === this.steps.NOTI ?
          this.$t('LOGIN.GO_TO_LOGIN_PAGE') :
          this.step !== this.steps.OTP ? this.$t('APP.CONTINUE') : null;
    },
    passwordRules() {
      const password = this.data.password;
      return [
        {
          text: this.$t('USERNAME_PASSWORD.PASSWORD_RULES.AT_LEAST_8_CHARACTERS'),
          value: password && password.length >= 8,
        },
        {
          text: this.$t('USERNAME_PASSWORD.PASSWORD_RULES.AT_LEAST_A_LOWERCASE'),
          value: password && /(.*[a-z].*)/.test(password)
        },
        {
          text: this.$t('USERNAME_PASSWORD.PASSWORD_RULES.AT_LEAST_A_UPPERCASE'),
          value: password && /(.*[A-Z].*)/.test(password)
        },
        {
          text: this.$t('USERNAME_PASSWORD.PASSWORD_RULES.AT_LEAST_A_NUMBER'),
          value: password && /(.*\d.*)/.test(password)
        },
        {
          text: this.$t('USERNAME_PASSWORD.PASSWORD_RULES.AT_LEAST_A_SPECIAL_CHARACTER'),
          value: password && /(.*\W.*)/.test(password)
        },
      ]
    }
  },
  watch: {
    "data.otp": {
      handler() {
        this.error = "";
        if (this.submitCb) {
          this.submitCb();
        }
      },
    }
  },
  methods: {
    resetState() {
      this.resendLoading = {
        [OtpType.SMS]: 0,
        [OtpType.EmailOtp]: 0,
      }
      this.data.otp = "";
      this.error = "";
      if (this.submitCb) {
        this.submitCb();
      }
    },
    async submit(cb) {
      if (cb) {
        this.submitCb = cb;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        if (this.step === 1) {
          this.requestChangePassRes = await msDataProvider.executeCommand('requestChangePassword', {
            loginName: this.data.loginName
          })
          this.otpTypeItems = this.requestChangePassRes.available_mfas;
          if (this.otpTypeItems) {
            this.selectedTypeItem = this.requestChangePassRes.type;
          }
          if (this.requestChangePassRes.error_info.error_code) {
            this.error = this.requestChangePassRes.error_info.message;
            this.loading = false;
            this.submitCb();
            if (this.requestChangePassRes.error_info.error_code === 1 || this.requestChangePassRes.error_info.error_code === 405) {
              ++this.step;
            }
            return;
          }
        }
        if (this.step === 2) {
          const res = await msDataProvider.executeCommand('verifyChangePassword', {
            type: this.selectedTypeItem,
            otp: this.data.otp,
            requestId: this.requestChangePassRes.request_id,
            loginName: this.data.loginName
          })
          if (res.error_info.error_code) {
            this.submitCb();
            this.error = res.error_info.message;
            this.loading = false;
            return;
          }
        }
        if (this.step === 3) {
          const res = await msDataProvider.executeCommand('resetPassword', {
            type: this.selectedTypeItem,
            newPassword: this.data.password
          })
          if (res.message) {
            this.submitCb();
            this.loading = false;
            this.error = res.message;
            return;
          }
        }
        if (this.step === this.steps.NOTI) {
          await this.$router.push('/login/prepare');
          return;
        }
        this.resetState();
        this.step += 1;
      } catch (e) {
        if (this.submitCb) {
          this.submitCb(e);
          this.error = " ";
        }
        this.loading = false;
      }
      this.loading = false;
    },
    async sleep(ms) {
      await new Promise((resolve) => setTimeout(resolve, ms));
    },
    async handleKeyDownEventOtp(e: KeyboardEvent) {
      this.errorPrepare = "";
      if (!((e.keyCode >= 48 && e.keyCode <= 57) ||
          e.keyCode === 39 || e.keyCode === 37 ||
          (e.keyCode >= 96 && e.keyCode <= 105) ||
          e.keyCode === 8 || e.keyCode === 46) && !(e.keyCode === 86 && e.ctrlKey)) {
        // only 0-9, backspace, delete button, left arrow, right arrow
        e.preventDefault();
      }
    },
    handleKeyUpEventOtp() {
      if (TOTP_REGEX.test(this.data.otp)) {
        if (this.data.otp.length === 6) {
          this.submit(null);
        }
      }
    },
    async handlePaste(e) {
      const text = await e.clipboardData.getData('text');
      if (isNaN(+text)) {
        e.preventDefault();
        return;
      }
      if (text.length >= 6) {
        setTimeout(() => {
          this.submit(null);
        })
      }
    },
    async changeOtpType(item) {
      this.error = "";
      this.data.otp = "";
      if (this.submitCb) {
        this.submitCb();
      }
      this.selectedTypeItem = item;
      await this.requestChangePassword();
    },
    async requestChangePassword() {
      try {
        this.pageOtpLoading = true;
        this.requestChangePassRes = await msDataProvider.executeCommand('requestChangePassword', {
          loginName: this.data.loginName,
          type: this.selectedTypeItem
        })
        if (this.requestChangePassRes.type) {
          this.selectedTypeItem = this.requestChangePassRes.type;
        }
        if (this.requestChangePassRes.error_info.error_code === 405 && this.otpTypeItems.length) {
          uiService.executeCommand('alertShow', {
            title: this.$t('APP.WARNING'),
            message: this.requestChangePassRes.error_info.message,
            cancel: this.$t('APP.CLOSE'),
            closeCallBack: () => {
              this.selectedTypeItem = this.otpTypeItems[0];
              this.requestChangePassword();
            }
          })
        } else if (this.requestChangePassRes.error_info.error_code) {
          this.error = this.requestChangePassRes.error_info.message;
        }
        this.otpTypeItems = this.requestChangePassRes.available_mfas || [];
      } catch (e) {
        if (this.submitCb) {
          this.submitCb(e);
          this.error = " ";
        }
        this.pageOtpLoading = false;
      } finally {
        this.pageOtpLoading = false;
      }
    },
    async resendOtp() {
      if (this.resendLoading[this.selectedTypeItem] > 0 || this.pageOtpLoading) {
        return;
      }
      this.resendLoading[this.selectedTypeItem] = 30;
      await this.requestChangePassword();
      const type = this.selectedTypeItem;
      const countResend = setInterval(() => {
        --this.resendLoading[type];
        if (this.resendLoading[type] <= 0 || this.step !== this.steps.OTP) {
          clearInterval(countResend);
          this.resendLoading[type] = 0;
        }
        this.$forceUpdate();
      }, 1000);
    },
    async back() {
      this.resetState();
      switch (this.step) {
        case this.steps.USERNAME:
          return this.$router.back();
        case this.steps.OTP:
          this.step = this.steps.USERNAME;
          return;
        case this.steps.NEW_PASSWORD:
          if (
              await uiService.executeCommand(
                  "confirmShow",
                  {
                    message: this.$t('LAYOUT.DO_YOU_REALLY_WANT_TO_EXIT_THIS_PAGE'),
                    title: this.$t('LAYOUT.CONFIRM'),
                    cancel: this.$t('LAYOUT.CANCEL'),
                    ok: this.$t('LAYOUT.CONFIRM_EXIT'),
                  },
                  true
              )
          ) {
            this.$router.push('/login/prepare');
          }
          return;
        case this.steps.NOTI:
          this.$router.push('/login/prepare');
          return;
      }
    },
    goToLogin() {
      this.$router.push('/login/prepare')
    },
  },
  created() {
  }
})
